import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Sidebar from "../../../../../partials/aside/Sidebar";
import httpService from "../../../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../../../helpers/spinner";

function InfoDeletedCampaign() {
  const params = useParams();
  const campaignID = params.id;
  const initCampaign = {
    name: "",
    category: "",
    active: "",
  };

  const [campaign, setCampaign] = useState(initCampaign);

  useEffect(() => {
    getCampaignInfoDeleted(campaignID);
  }, []);

  const getCampaignInfoDeleted = async (campaignID) => {
    setCampaign(await sendRequestGetCampaignInfoDeleted(campaignID));
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetCampaignInfoDeleted = async (campaignID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const headersRequest = getHeaderForRequest();
    let campaignInfo;
    try {
      campaignInfo = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/campaign/manage/banner/simple/deleted/" +
          campaignID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return campaignInfo.data.data;
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  ویرایش تنظیمات نمایش کمپین بنری ساده
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12 ">
                    <div>
                      <table className="table table-bordered table-dark tbl-td-white-space table-hover">
                        <tr>
                          <td className="text-info">شماره کمپین</td>
                          <td>{campaign.id}</td>
                        </tr>
                        <tr>
                          <td className="text-info">نام کمپین</td>
                          <td>{campaign.name}</td>
                        </tr>

                        <tr>
                          <td className="text-info">شماره دسته</td>
                          <td>{campaign.category_id}</td>
                        </tr>
                        <tr>
                          <td className="text-info">نام دسته</td>
                          <td>{campaign.category}</td>
                        </tr>

                        <tr>
                          <td className="text-info">وضعیت</td>
                          <td>{campaign.active ? "فعال" : "غیرفعال"}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default InfoDeletedCampaign;
